import { createRoot } from "react-dom/client";
import App from "./App";
import { startLedgerOutboxAutoFlush } from "./lib/ledger-outbox";
import { registerAppServiceWorker } from "./lib/service-worker";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Application root was not found");

createRoot(root).render(<App />);

startLedgerOutboxAutoFlush();
if (import.meta.env.PROD) void registerAppServiceWorker();
